export default (cookie_name) => {
    if (["trip_id", "trip_id_version", 'trip_token'].includes(cookie_name)) {
        const saved = sessionStorage.getItem(cookie_name);
        const data = saved ? JSON.parse(saved) : "";
        return data;
    }
    cookie_name += "=";
    let cookie = decodeURIComponent(document.cookie);
    let cookie_array = cookie.split(";");
    for (let i = 0; i < cookie_array.length; i++) {
        while (cookie_array[i].charAt(0) === " ") {
            cookie_array[i] = cookie_array[i].substring(1);
        }
        if (cookie_array[i].indexOf(cookie_name) === 0) {
            return cookie_array[i].substring(cookie_name.length, cookie_array[i].length);
        }
    }
    return "";
}